import { useRef } from "react";

function useContainerRef() {
  const containerRef = useRef();
  const getContainer:any = () => containerRef.current;
  return { containerRef, getContainer };
}

export default useContainerRef;
